enum ScrollBehavior {
  SMOOTH = 'smooth',
  AUTO = 'auto',
}

const SCROLL_TOP_ACTION_PROPS = {
    behavior: ScrollBehavior.SMOOTH,
    top: 0,
  },
  SCROLL_TOP_DEBOUNCE_TIMER = 250;

export { SCROLL_TOP_ACTION_PROPS, SCROLL_TOP_DEBOUNCE_TIMER };
